import { Dependencies } from "../interfaces/dependencies-types";
import { obfButtonsDataAttributes } from "../interfaces/obf-buttons-cta-attributes.interface";

export class CtaButtonsController implements Dependencies {

    private ctaHandler: (button: HTMLElement, buttonAttributes: obfButtonsDataAttributes) => void = null;

    private attributes = [
        {
            attribute: 'data-default-service-category',
            key: 'default_category_title',
            dep: true,
            newAttribute: 'data-default-category-title',
        },
        {
            attribute: 'data-default-service-type',
            key: 'default_service_title',
            dep: true,
            newAttribute: 'data-default-service-title',
        },
        { attribute: 'data-default-category-id', key: 'default_category_id', dep: false },
        { attribute: 'data-default-service-id', key: 'default_service_id', dep: false },
        { attribute: 'data-default-category-title', key: 'default_category_title', dep: false },
        { attribute: 'data-default-service-title', key: 'default_service_title', dep: false },
        { attribute: 'data-screen', key: 'screen', dep: false }
    ];

    private buttonsSelector = '[data-book-btn], [data-book-btn] *, [data-free-quote-btn], [data-free-quote-btn] *, a[href*="#open-booking-form"] *, a[href*="#open-booking-form"]';

    public async initialize() {

        this.setEventListenersForCTA();
    }

    public setCTAHandler(handler: (button: HTMLElement, buttonAttributes: obfButtonsDataAttributes) => void) {
        this.ctaHandler = handler;
    }

    public removeCTAHandler() {
        this.ctaHandler = null;
    }

    private setEventListenersForCTA() {

        document.body.addEventListener('click', (e: any) => {

            let element;
            const target = e.target;

            if (typeof target.matches !== 'undefined') {
                element = target.matches(this.buttonsSelector);
            } else if (typeof target.matchesSelector !== 'undefined') {
                element = target.matchesSelector(this.buttonsSelector);
            } else if (typeof target.msMatchesSelector !== 'undefined') {
                element = target.msMatchesSelector(this.buttonsSelector);
            } else if (typeof target.webkitMatchesSelector !== 'undefined') {
                element = target.webkitMatchesSelector(this.buttonsSelector);
            }

            if (element) {
                let button: any = this.findObfButton(e.target, 0);
                if ((button && button.getAttribute('data-book-btn') || button.getAttribute('data-free-quote-btn') || button.getAttribute('href').includes('#open-booking-form')) && !button.getAttribute('data-book-loading')) {
                    if (this.ctaHandler) {
                        this.ctaHandler(button, this.getButtonAttribute(button))
                    }
                }
                e.preventDefault();
            }
        });
    }

    private getButtonAttribute(buttonRef: any): obfButtonsDataAttributes {
        const buttonAttributes: obfButtonsDataAttributes = {};
        this.attributes.map(el => {
            if (buttonRef.href && buttonRef.href.includes('#open-booking-form')) {
                const params = buttonRef.href.split('|');
                params.map(param => {
                    const property = el.key.replace(/\_/g, '-') + '=';
                    if (param.includes(property)) {
                        buttonAttributes[el.key] = param.substring(property.length, param.length);
                    }
                });
            } else {
                let attr = buttonRef.getAttribute(el.attribute);
                if (attr) {
                    buttonAttributes[el.key] = attr;

                    if (el.dep) {
                        console.warn(
                            'WARNING!Button property "' + el.attribute + '" has been deprecated, please use the new "' +
                            el.newAttribute
                            + '" property instead!'
                        );
                    }
                }
            }
        });
        return buttonAttributes;
    }

    private findObfButton(target: any, index: number): any {
        index += 1;

        if (index == 11) {
            // search only to 10 parent element in dom
            return null;
        }

        if (target.getAttribute('data-book-btn') || target.getAttribute('data-free-quote-btn') || target.href && target.href.includes('#open-booking-form')) {
            return target;
        } else {
            return this.findObfButton(target.parentElement, index);
        }
    }

    /**
    * Remove button spinner
    */
    public removeSpinners() {
        const buttons = this.getButtons();
        for (let i = 0; i < buttons.length; i++) {
            let currentButton = buttons[i];

            if (currentButton.getAttribute('data-initial-html')) {
                currentButton.innerHTML = buttons[i].attributes['data-initial-html'].value;

                currentButton.style.width = currentButton.getAttribute('data-width');
                currentButton.style.height = currentButton.getAttribute('data-height');
                currentButton.style.padding = currentButton.getAttribute('data-padding');
                currentButton.style.verticalAlign = currentButton.getAttribute('data-vertical-align');
                currentButton.style['pointer-events'] = null;
                currentButton.style.opacity = null;

                currentButton.removeAttribute('data-initial-html');
                currentButton.removeAttribute('data-width');
                currentButton.removeAttribute('data-height');
                currentButton.removeAttribute('data-padding');
                currentButton.removeAttribute('data-vertical-align');
                currentButton.removeAttribute('data-book-loading');
            }
        }

        return false;
    }

    /**
    * Add button spinner
    */
    public addSpinners(button?:any) {
        if(button) {
            this.modifyButton(button);
        } else {
            const buttons = this.getButtons();
            for (let i = 0; i < buttons.length; i++) {
                let currentButton = buttons[i];
    
                if (currentButton.offsetWidth === 0 || currentButton.offsetHeight === 0) {
                    continue;
                }

                this.modifyButton(currentButton);
            }
        }

        return true;
    }

    private modifyButton(currentButton:any) {
        
        let buttonHTML = currentButton.innerHTML,
        buttonStyle = currentButton.getAttribute('style') || '';

        currentButton.setAttribute('data-book-loading', 'true');
    
        currentButton.setAttribute('data-initial-html', buttonHTML);
        currentButton.setAttribute('data-width', currentButton.style.width);
        currentButton.setAttribute('data-height', currentButton.style.height);
        currentButton.setAttribute('data-padding', currentButton.style.padding);
        currentButton.setAttribute('data-vertical-align', currentButton.style.verticalAlign);
    
        let initialWidth = currentButton.offsetWidth === 0 ? '' : currentButton.offsetWidth,
            initialHeight = currentButton.offsetHeight === 0 ? '' : currentButton.offsetHeight;
    
        if (window.getComputedStyle(currentButton).getPropertyValue('position') === 'static') {
            currentButton.style.position = 'relative';
        }
    
        currentButton.style['pointer-events'] = 'none';
    
        let smallerValue = initialWidth < initialHeight ? initialWidth : initialHeight,
            textColor = window.getComputedStyle(currentButton).getPropertyValue('color');
    
            let loaderElement = '<span class="add-obf-btn-spinner" style="border-top-color:'+textColor+';"></span>';
    
        currentButton.innerHTML = buttonHTML + loaderElement;
        currentButton.style.width = initialWidth + 'px';
        currentButton.style.height = initialHeight + 'px';
        // currentButton.style.padding = '0';
        currentButton.style.opacity = '0.6';
    
        if (!currentButton.style.verticalAlign) {
            currentButton.style.verticalAlign = 'middle';
        }
    }

    /**
    * Get all obf buttons and return them
    */
    private getButtons() {
        let matches: any;

        matches = document.querySelectorAll(this.buttonsSelector);

        return matches;
    }
}
